/** Duration in ms for the highlight border animation */
export const LEVEL_ACTION_HIGHLIGHT_DURATION_MS = 5000;
